module.exports = __webpack_public_path__ + "img/sd-logo.ff8843f1.svg";